// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Zn3q","footer":"Form_footer__Rz95t"};